export default __webpack_public_path__ + "static/media/logout.dcb33723.svg";